import mergeDeep from 'deepmerge'
import { pick } from "../utils";
import { AppActions, AppState } from "../types";

const overwriteMerge = (destinationArray: any, sourceArray: any) => sourceArray

const isVersionMatch = (stateVersion: string, payloadVersion: string) => stateVersion === payloadVersion;
//Checks if the version variable from config is less than the current variable.
//TODO: Only used for updating the config in state. Ideally should be applied to everything as checking a direct version match means that previous versions can overwrite current versions
//and that config specific variable overwrites are not considered if they're the same variable.
const isVersionLess = (stateVersion: string, payloadVersion: string) => stateVersion > payloadVersion;

const reducer = (state: AppState, { payload, type }: AppActions): AppState => {
  switch (type) {
    case 'ADD_MESSAGE':
      return {
        ...state,
        ...{
          messages: [...state.messages, payload]
        }
      }
    case 'DELETE_MESSAGE':
      return {
        ...state,
        ...{
          messages: state.messages.filter(({ id }) => id !== payload)
        }
      }
    case 'SET_PLANS':
      return {
        ...state,
        plans: payload
      }
    case 'UPDATE_BILLING_STATUS':
      return {
        ...state,
        billingStatus: payload
      }
    case 'UPDATE_CONFIG':
      if (isVersionLess(state.config.version, payload.version)) {
        return state
      } else {
        return {
          ...state,
          ...{
            config: mergeDeep(state.config, payload, { arrayMerge: overwriteMerge })
          }
        }
      };
    case 'UPDATE_FORM_DATA':
      return {
        ...state,
        ...{
          form: { ...state.form, ...payload }
        }
      }
    case 'UPDATE_QUERY_PARAMS':
      /**
       * Pick out ONLY the url params that our app needs
       */
      const validConfigs = ['config', 'locale', 'voucher', 'accessCode', 'userID', 'token'];

      return {
        ...state,
        ...{
          params: mergeDeep(state.params, pick(payload, validConfigs))
        },
      };
    case 'UPDATE_PLANS': {
      return {
        ...state,
        ...{
          plans: state.plans.map(plan => plan.productId === payload.productId ? payload : plan)
        }
      }
    }
    case 'UPDATE_FALLBACK_TRANSLATIONS':
      if (isVersionLess(state?.translations?.fallback?.version, payload?.version)) {
        return state
      } else {
        return {
          ...state,
          ...{
            translations: {
              ...state.translations,
              fallback: payload
            }
          }
        };
      };
    case 'UPDATE_LOCALE_TRANSLATIONS':
      if (isVersionLess(state?.translations[state.params.locale]?.version, payload?.version)) {
        return state
      } else {
        return {
          ...state,
          ...{
            translations: {
              ...state.translations,
              [state.params.locale]: payload
            }
          }
        };
      };
    case 'UPDATE_DEFAULT_THEME':
      if (!isVersionMatch(state.config.theme.version, payload.version)) {
        return {
          ...state,
          ...{
            config: {
              ...state.config,
              theme: payload
            }
          }
        };
      } else {
        return state
      };
    case 'UPDATE_USER':
      return {
        ...state,
        ...{
          user: { ...state.user, ...payload }
        }
      }
    case 'UPDATE_SKIP_PAYMENT':
      return {
        ...state,
        ...{
          skipPayment: {...payload}
        }
      }
      case 'UPDATE_PAYMENT_BUTTONS':
      return {
        ...state,
        ...{
          paymentButtons: {...payload}
        }
      }
    default:
      throw new Error('Action invalid.');
  }
};

export default reducer